import trashIcon from '@jetbrains/icons/trash.svg'
import Button from '@jetbrains/ring-ui/components/button/button'
import React from 'react'

import styles from '../MatrixParamBuild.css'

import MatrixParamBuildParameterValue from './MatrixParamBuildParameterValue/MatrixParamBuildParameterValue'
import type {MatrixParamBuildParameterValuesProps} from './MatrixParamBuildParameterValues.types'
import useMatrixParamBuildParameterValues from './useMatrixParamBuildParameterValues'

function MatrixParamBuildParameterValues({
  parameterIndex,
  values,
  options,
  disabled,
}: MatrixParamBuildParameterValuesProps) {
  const {
    isAllowDelete,
    parameterValues,
    valueDuplicates,
    valueSelectOptions,
    latestInputValueRef,
    deleteParameterValueButtonClickHandler,
    addParameterValueButtonClickHandler,
  } = useMatrixParamBuildParameterValues(parameterIndex, values, options)

  return (
    <div>
      <label className={styles.label}>{'Parameter value'}</label>
      {parameterValues.map((value, index) => {
        const parameterValuesLength = parameterValues.length
        const key = `${index}-${values.length}`
        const isDuplicate = Boolean(valueDuplicates.get(value))
        const isFirst = index === 0
        const isLast = index === parameterValuesLength - 1
        const matrixParamBuildParameterValueRef = isLast ? latestInputValueRef : null

        return (
          <div key={key} className={styles.row}>
            <MatrixParamBuildParameterValue
              isFirst={isFirst}
              value={value}
              options={valueSelectOptions}
              parameterIndex={parameterIndex}
              isDuplicate={isDuplicate}
              index={index}
              ref={matrixParamBuildParameterValueRef}
              disabled={disabled}
            />
            {isAllowDelete && (
              <div className={styles.deleteButton}>
                <Button
                  onClick={deleteParameterValueButtonClickHandler(index)}
                  icon={trashIcon}
                  disabled={disabled}
                  title="Delete value"
                />
              </div>
            )}
          </div>
        )
      })}

      <Button disabled={disabled} inline text onClick={addParameterValueButtonClickHandler}>
        {'Add another value'}
      </Button>
    </div>
  )
}
export default MatrixParamBuildParameterValues
